import script from "./EmployersPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmployersPage.vue?vue&type=script&setup=true&lang=ts"

import "./EmployersPage.vue?vue&type=style&index=0&id=1d29ddb7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d29ddb7"]])

export default __exports__